import { Trans, useTranslation } from "react-i18next";
import StyledSpinner from "@/components/styled/StyledSpinner";
import { useDeleteRib } from "@/api/rib.api";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { RibDto } from "@/types/api/api-types";

type OptionsRibDeleteModalProps = {
  closeModal: () => void;
  rib: RibDto;
};

export const OptionsRibDeleteModal = ({ closeModal, rib }: OptionsRibDeleteModalProps) => {
  const { t } = useTranslation(["boParameters", "common"]);
  const { mutate: deleteRib, isPending } = useDeleteRib();

  const handleDelete = () => {
    if (isPending) return;
    deleteRib(rib.id, { onSuccess: closeModal });
  };

  return (
    <Modal
      open
      onClose={closeModal}
      title={t("ribDeleteModal.title")}
      size="sm"
      footer={
        <div className="flex w-full flex-col gap-2">
          <Button
            type="button"
            variant="destructive"
            onClick={handleDelete}
            disabled={isPending}
            className="w-full"
          >
            {isPending ? <StyledSpinner /> : t("ribDeleteModal.submit")}
          </Button>
          <Button variant="outline" onClick={closeModal} disabled={isPending} className="w-full">
            {t("common:actions.cancel")}
          </Button>
        </div>
      }
    >
      <p>
        <Trans
          t={t}
          i18nKey="ribDeleteModal.description"
          values={{ shortenName: rib.shortenName }}
          components={{ bold: <strong /> }}
        />
      </p>
    </Modal>
  );
};
